<template>
    <svg :class="[width, height]" viewBox="0 0 18 18">
        <g id="Arrow_-_Right" data-name="Arrow - Right" transform="translate(2.25 4.5)">
            <path id="Arrow_-_Right-2" data-name="Arrow - Right"
                  d="M6.861,8.836a1.417,1.417,0,0,1-.606-.678,7.3,7.3,0,0,1-.2-.8A16.78,16.78,0,0,1,5.877,4.77V4.5a20.39,20.39,0,0,1,.162-2.766l.085-.408A2.914,2.914,0,0,1,6.3.744,1.361,1.361,0,0,1,7.5,0h.043A3.768,3.768,0,0,1,8.551.306a16.954,16.954,0,0,1,4.194,2.842l.284.3a2.611,2.611,0,0,1,.211.25,1.325,1.325,0,0,1,.26.8,1.39,1.39,0,0,1-.281.853l-.292.315-.065.067A16.561,16.561,0,0,1,8.443,8.748l-.183.07A3.049,3.049,0,0,1,7.544,9,1.5,1.5,0,0,1,6.861,8.836ZM0,4.5A1.133,1.133,0,0,1,1.127,3.361L3.9,3.607a.893.893,0,0,1,0,1.786l-2.775.246A1.133,1.133,0,0,1,0,4.5Z"
                  fill="#f8d397"/>
        </g>
    </svg>

</template>

<script>
export default {
    name: "SkipIcon",
    props: {
        width: {
            type: String,
            default: "w-[18px]"
        },
        height: {
            type: String,
            default: "h-[18px]"
        },
    }
}
</script>
